module.exports = __webpack_public_path__ + "img/2-2.35b8a313.png";